// extracted by mini-css-extract-plugin
module.exports = {"registerWrapper":"registerpage_registerWrapper__2uI5x","registerPage":"registerpage_registerPage__3IEZy","registerBack":"registerpage_registerBack__3p6s4"};